import * as React from 'react';
import { AuditForm, AuditModal } from '../../../auditmodal/components/AuditModal';
import { useCurrentStudyConfigurationContext } from '../../../Core/CurrentStudyConfigurationContext';
import { AuditTrailActionEnum } from '../../../misc/api/ApiAuditActions';
import { useCoughMarshalApiClient } from '../../../misc/api/CoughMarshalApiClient';
import { useWebPortalApiClient } from '../../../misc/api/WebPortalTokenClient';
import { CoughSessionStatusEnum } from "../../../misc/api/apiTypes";

interface BatchReprocessProps {
    algorithm: 'all' | 'manchester' | 'abacas' | 'vta-ct1' | 'hidden';
    onClose: () => void;
}

export const BatchReprocessModal = (props: BatchReprocessProps) => {
    const cmClient = useCoughMarshalApiClient();
    const client = useWebPortalApiClient();
    const [submitting, setSubmitting] = React.useState(false);
    const [error, setError] = React.useState<string | undefined>();
    const { study } = useCurrentStudyConfigurationContext();

    const onSubmit = async (auditForm: AuditForm) => {
        setSubmitting(true);
        setError(undefined);

        const sessionsResult = await client.client.getCoughSessions("id", `visit/subject/site/studyId eq ${study.id} and status eq '${CoughSessionStatusEnum.AnalysisComplete}'`);

        for (const session of sessionsResult.value) {
            try {
                await cmClient.reProcessRequestForQueue(session.id, props.algorithm);
                await client.client.patchCoughSession({
                    status: CoughSessionStatusEnum.AwaitingProcessing,
                }, session.id, "");


                await client.client.postAuditTrailEvent({
                    summary: `The batch processing of cough sessions has been triggered.`,
                    auditAction: AuditTrailActionEnum.BatchProcessCoughSessionsTriggered,
                    userAnnotation: auditForm.Annotation,
                });
            } catch (ex) {
                setSubmitting(false);
                setError(`Failed to re-process session ${session.id}: ${ex}`);
                return;
            }
        }

        setSubmitting(false);
        props.onClose();
    }

    if (props.algorithm === 'hidden')
        return null;

    return (
        <AuditModal header="Trigger re-processing for all sessions"
            isSubmitting={submitting}
            warning={error ? null : "Are you sure you wish to continue? This will schedule all 'analysis complete' sessions for re-processing."}
            error={error}
            onClose={() => props.onClose()}
            onSubmit={(annotation) => onSubmit(annotation)}
        />
    );
}
